import { useEffect, useRef } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useNavigate } from "react-router-dom";
import ModelIndex, { ModelIndexHandle } from "@components/layout/ModelIndex";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { showAlert } from "@utils/Alert";
import { ExpenseCategoryApi, ExpenseCategoryDataType } from "@/api/ExpenseCategoryApi";

const ExpenseCategoryIndex = () => {
  const navigate = useNavigate();
  const modelRef = useRef<ModelIndexHandle>(null);

  useEffect(() => {
  }, []);

  const deleteRecord = async (id: string) => {
    const { errors } = await ExpenseCategoryApi.delete(id);
    if (errors?.length) {
      showAlert('danger', 'La Categoria de Gastos no puedo ser eliminado');
    } else {
      showAlert('success', 'La Categoria de Gastos fue eliminado correctamente');
    }
    modelRef.current?.refetch();
  }

  return (
    <PageContainer
      title="Lista de Categoria de Gastos"
      backUrl="/user/dashboard-accounting"
      primaryActions={[
        {
          onClick: () => {
            navigate('/user/expenses/category')
          },
          actionTitle: "Nuevo",
          color: "success"
        }
      ]}
    >
      <ModelIndex<ExpenseCategoryDataType>
        ref={modelRef}
        fetchData={(...args) => ExpenseCategoryApi.fetchAll(...args)}
        filterProps={[
          {
            key: "codigo",
            filterType: "eq",
            type: "number"
          },
          {
            key: "title",
            filterType: "contains"
          }
        ]}
        secondaryProperties={[
          {
            key: "codigo",
          },
          {
            key: "title",
          },
          {
            key: "is_default",
            optionalHighlighted: (val: any) => { return val == "true" },
            highlightedText: "Predeterminada",
            nonHighlightedText: "No Predeterminada"
          }
        ]}
        listActions={[
          {
            href: "/user/expenses/category/{:id}",
            actionTitle: "Editar Categoria de Gastos",
            iconProps: { icon: faEdit }
          },
          {
            actionTitle: "Eliminar Categoria de Gastos",
            iconProps: { icon: faTrash },
            needConfirm: true,
            confirmProps: {
              title: "Eliminar Categoria de Gastos",
              confirmMessage: "¿Seguro que desea eliminar esta Categoria de Gastos?",
              confirmBtnText: "Eliminar"
            },
            onClick: (id: string) => { deleteRecord(id) }
          }
        ]}
      >
      </ModelIndex>

    </PageContainer >
  );
}

export default ExpenseCategoryIndex;
